<template>
  <v-row class="pt-5" v-if="doc">
    <v-col cols="3">
      <div class="pl-5">
        <p class="blue--text headline">Audience</p>
        <ul class="list--none">
          <li class="ma-1" v-for="(tag, index) in doc.audience" :key="index">
            <span class="pr-2">{{ tag.title }}</span>
          </li>
        </ul>

        <p class="green--text headline mt-10">Features</p>
        <ul class="list--none">
          <li class="ma-1" v-for="(tag, index) in doc.features" :key="index">
            <span class="pr-2">{{ tag.title }}</span>
          </li>
        </ul>

        <p class="deep-orange--text headline mt-10">Benefits</p>
        <ul class="list--none">
          <li class="ma-1" v-for="(tag, index) in doc.benefits" :key="index">
            <span class="pr-2">{{ tag.title }}</span>
          </li>
        </ul>

        <p class="pink--text headline mt-10">Evidence</p>
        <ul class="list--none">
          <li class="ma-1" v-for="(tag, index) in doc.reasons" :key="index">
            <span class="pr-2">{{ tag.title }}</span>
          </li>
        </ul>
      </div>
    </v-col>
    <v-col cols="8">
      <v-row>
        <v-col cols="2" class="ma-0">
          <p class="headline">For</p>
        </v-col>
        <v-col class="ma-0">
          <div class="headline" v-html="doc.textAudience"></div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2" class="ma-0">
          <p class="headline"></p>
        </v-col>
        <v-col class="ma-0">
          <div class="headline" v-html="doc.textCompany"></div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2" class="ma-0">
          <p class="headline">Is</p>
        </v-col>
        <v-col class="ma-0">
          <div class="headline" v-html="doc.textFeatures"></div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2" class="ma-0">
          <p class="headline">That</p>
        </v-col>
        <v-col class="ma-0">
          <div class="headline" v-html="doc.textBenefits"></div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2" class="ma-0">
          <p class="headline">Because</p>
        </v-col>
        <v-col class="ma-0">
          <div class="headline" v-html="doc.textEvidence"></div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

export default {
  name: "ResultsPropositionUser",
  data() {
    return {
      doc: null,
    };
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise();
      }
    },
  },
  mounted() {
    this.getExercise();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getExercise() {
      this.doc = null;
      // get a ref to the exercise and listen to changes
      let ref = fb.propositionExCollection
        .where("pid", "==", this.id)
        .where("uid", "==", this.uid);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.doc = items[0].doc;
          }
        })
        .catch(function() {});
    },
  },
};
</script>
